(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sub-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh-room-carousel')) {
  customElements.define('bh-room-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.viewport = this.querySelector('[data-bh-viewport]');
      this.track = this.querySelector('[data-bh-track]');
      this.cards = Array.from(this.track.children);
      if (this.cards.length < 2) return;
      this.ready = true;
      this.abort = new AbortController();
      const on = (el, type, fn, extra = {}) => el.addEventListener(type, fn, {signal: this.abort.signal, ...extra});
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.speed = Number(this.dataset.speed) || 18;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.cooldown = 0;
      const clone = card => {
        const copy = card.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.dataset.bhClone = '';
        copy.removeAttribute('id');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        copy.querySelectorAll('[data-bh-reveal]').forEach(el => el.removeAttribute('data-bh-reveal'));
        copy.querySelectorAll('a, button, [tabindex]').forEach(el => el.tabIndex = -1);
        return copy;
      };
      this.track.prepend(...this.cards.map(clone));
      this.track.append(...this.cards.map(clone));
      this.classList.add('bh-ready');
      this.resize = new ResizeObserver(() => {
        const width = this.viewport.clientWidth;
        const gap = width < 600 ? 16 : 24;
        const count = width < 600 ? 1.15 : width < 950 ? 2.15 : 3.15;
        const phase = this.cycle ? (this.viewport.scrollLeft % this.cycle) / this.cycle : 0;
        this.style.setProperty('--bh-gap', `${gap}px`);
        this.style.setProperty('--bh-card-width', `${(width - gap * (count - 1)) / count}px`);
        this.step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
        this.cycle = this.step * this.cards.length;
        this.viewport.scrollLeft = this.cycle * (1 + phase);
      });
      this.resize.observe(this.viewport);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, {threshold: 0.01});
      this.observer.observe(this);
      on(this.viewport, 'dragstart', e => e.preventDefault());
      on(this.viewport, 'wheel', () => { this.cooldown = performance.now() + 1800; }, {passive: true});
      on(this.viewport, 'pointerdown', e => {
        if (!e.isPrimary || e.button !== 0) return;
        this.pointer = {id: e.pointerId, x: e.clientX, y: e.clientY, scroll: this.viewport.scrollLeft, dragging: false};
        this.tween = null;
        this.cooldown = performance.now() + 1800;
      });
      on(this.viewport, 'pointermove', e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId) return;
        const dx = e.clientX - p.x;
        const dy = e.clientY - p.y;
        if (!p.dragging) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.pointer = null; return; }
          if (Math.abs(dx) < 6) return;
          p.dragging = true;
          if (this.viewport.contains(document.activeElement)) document.activeElement.blur();
          this.focused = false;
          this.viewport.setPointerCapture(e.pointerId);
          this.classList.add('bh-dragging');
        }
        e.preventDefault();
        this.viewport.scrollLeft = p.scroll - dx;
        this.wrap();
      });
      const release = e => {
        if (!this.pointer || this.pointer.id !== e.pointerId) return;
        if (this.pointer.dragging) this.suppressClickUntil = performance.now() + 450;
        this.pointer = null;
        this.classList.remove('bh-dragging');
        if (this.viewport.hasPointerCapture(e.pointerId)) this.viewport.releasePointerCapture(e.pointerId);
        this.cooldown = performance.now() + 1800;
      };
      on(this.viewport, 'pointerup', release);
      on(this.viewport, 'pointercancel', release);
      on(this.viewport, 'lostpointercapture', release);
      on(window, 'pointerup', release);
      on(this.viewport, 'click', e => {
        if (performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); e.stopPropagation(); }
      }, {capture: true});
      const advance = direction => {
        this.cooldown = performance.now() + 1800;
        if (this.motion.matches) { this.viewport.scrollLeft += direction * this.step; this.wrap(); return; }
        this.tween = {at: performance.now(), from: this.viewport.scrollLeft, distance: direction * this.step};
      };
      on(this.querySelector('[data-bh-prev]'), 'click', () => advance(-1));
      on(this.querySelector('[data-bh-next]'), 'click', () => advance(1));
      on(this.viewport, 'keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); advance(e.key === 'ArrowLeft' ? -1 : 1); }
      });
      on(this, 'shopify:block:select', e => {
        this.paused = true;
        const card = e.target.closest('.item');
        if (card) this.viewport.scrollLeft = card.offsetLeft;
      });
      const tick = now => {
        const elapsed = this.last ? Math.min(now - this.last, 50) : 0;
        this.last = now;
        if (this.tween) {
          const t = Math.min((now - this.tween.at) / 420, 1);
          this.viewport.scrollLeft = this.tween.from + this.tween.distance * (1 - Math.pow(1 - t, 3));
          if (t === 1) { this.tween = null; this.wrap(); }
        } else if (this.visible && !document.hidden && !this.paused && !this.pointer && now > this.cooldown) {
          this.carry = (this.carry || 0) + this.speed * elapsed / 1000;
          const pixels = Math.floor(this.carry);
          this.viewport.scrollLeft += pixels;
          this.carry -= pixels;
          this.wrap();
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    wrap() {
      if (!this.cycle) return;
      let shift = 0;
      if (this.viewport.scrollLeft < this.cycle * 0.5) shift = this.cycle;
      if (this.viewport.scrollLeft >= this.cycle * 1.5) shift = -this.cycle;
      if (shift) {
        this.viewport.scrollLeft += shift;
        if (this.pointer) this.pointer.scroll += shift;
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-bh-clone]').forEach(el => el.remove());
      this.classList.remove('bh-ready');
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
